import React, {useState, useEffect, useRef} from 'react';
import {inject, observer} from 'mobx-react';
import {Button, Input, Select, Pagination, Dropdown, Checkbox, DatePicker, Modal, Form, Radio, Spin} from 'antd';
import {Display} from '@/components/Display/Display';
import withRouter from '@/components/withRouter';
import {cloneDeep} from 'lodash';
import Toast from '@/components/Toast';
import ServiceUpload from '@/components/ServiceUpload';
import Utils, {getPrivateOrPublic, getCourseEditingUploadType, UploadType, formatDate} from '@/components/Utils';
import {
    handleCreate,
    handleGetTransInfoList,
    handleUpdateTitle,
    handleDelete,
    handleGetTransList,
    handleRetryTrans
} from '@/api/tingWu';
import {ConfirmTip} from './madalConfirm';
import {languageOptionsSearch, sourceLanguageOptions, speakerOptions} from './dict';
import s from './index.module.scss';
import {
    SyncOutlined,
    SearchOutlined,
    CloseOutlined,
    ExclamationCircleOutlined,
    PlusCircleOutlined
} from '@ant-design/icons';
import emtyImg from '@/assets/images/mobile/empty.png';
import uploadImg from '@/assets/images/tw/uploadImg.png';
import autioImg from '@/assets/images/tw/autioImg.png';
import videoImg from '@/assets/images/tw/videoImg.png';
import addIcon from '@/assets/images/tw/addIcon.png';
import addmoreIcon from '@/assets/images/tw/addmoreIcon.png';
import addIcon1 from '@/assets/images/tw/addIcon1.png';
import Record from '@/assets/images/record.png';
import {Storage} from '@/utils/Storage';
import dayjs from 'dayjs';
import {fetchCheckCanRecord} from "@/api/tingWu";

const {RangePicker} = DatePicker;
const MeetingPlatform = (props) => {
    const {grtAi} = props.store;
    const {agentId, toolId} = props?.params;
    const [records, setRecords] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [list, setList] = useState({});
    const [transList, setTransList] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [searchTextHig, setSearchTextHig] = useState('');
    const [sortValue, setSortValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(8);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [typeValue, setTypeValue] = useState('0');
    const [languageValue, setLanguageValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [timeSetting, setTimeSetting] = useState([]);
    const [isFilterClick, setIsFilterClick] = useState(false);
    const [isBatchClick, setIsBatchClick] = useState(false);
    const [listTitle, setListTitle] = useState('');
    const [listData, setListData] = useState({});
    const [form] = Form.useForm();
    const [visibleTitle, setVisibleTitle] = useState(false);
    const [params, setParams] = useState({});
    const [sourceLanguageVal, setSourceLanguageVal] = useState('cn');
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [isCheckCanUse, setIsCheckCanUse] = useState(false);
    const [isToolTw, setIsToolTw] = useState(false);
    const [retryLoading, setRetryLoading] = useState(false);
    const [visibleAdd, setVisibleAdd] = useState(false),
        [uploadList, setUploadList] = useState([]),
        [ossUploadList, setOssUploadList] = useState([]),
        tenant_id = Storage.get('tenantId');
    const fileListRef = useRef([]);

    const goLogin = () => {
        let redirect = `${window.location.href}`;
        window.location.href = `${origin}/login?redirect=${redirect}`;
    };
    const checkIsLogin = async () => {
        const res = await grtAi.checkLogin();
        if (res) {
            return true;
        }
        Toast.info('请登录');
        setTimeout(() => {
            goLogin();
        }, 500);
        return false;
    };
    const checkCanUseFun = async () => {
        const res = await grtAi.checkCanUseStudy(agentId);
        if (!res || !res.success || !res.data) {
            Toast.info('该智能体未对外开放使用，请联系管理员');
            setIsCheckCanUse(true);
        }
    };

    const handleAdd = () => {
        setUploadList([]);
        setOssUploadList([]);
        setVisibleAdd(true);
    };
    const handleAddRecord = () => {
        //@ts-ignore
        fetchCheckCanRecord().then((res) => {
            if (res.success && res.data) {
                return Toast.info('已经有一个实时录音未停止，请稍等～');
            }
            props.navigate(`/web/o/${agentId}/tools/${toolId}/add/record`);
        });
    };
    const onCancelAdd = () => {
        setUploadList([]);
        setOssUploadList([]);
        setVisibleAdd(false);
        fileListRef.current = [];
        setSourceLanguageVal('cn');
    };
    const handleGetTransListFun = async () => {
        const res = await handleGetTransList();
        if (res && res.success) {
            setTransList(res.data);
        } else {
            Toast.info(res?.msg || '查询失败');
        }
    };
    const handleRetryTransFun = async (ele) => {
        setRetryLoading(true);
        const res = await handleRetryTrans(ele.document_id);
        if (res && res.success) {
            setRetryLoading(false);
            handleGetTransListFun();
        } else {
            setRetryLoading(false);
            Toast.info(res?.msg || '查询失败');
            handleGetTransListFun();
        }
    };
    const handleGetTransInfoListFun = async (params, isTextHig) => {
        setSelectedRowKeys([]);
        setLoadingList(true);
        const res = await handleGetTransInfoList(params);
        if (res && res.success) {
            setRecords(res.data);
            setSearchTextHig(searchText);
            if (isTextHig) {
                setSearchTextHig('');
            }
            setList(res);
            setLoadingList(false);
        } else {
            Toast.info(res?.msg || '查询失败');
            setLoadingList(false);
        }
    };
    const handleCreateFun = async (data) => {
        const res = await handleCreate(data,agentId,toolId);
        if (res && res.success) {
            setLoadingBtn(false);
            setVisibleAdd(false);
            handleGetTransInfoListFun(params);
            handleGetTransListFun();
            setUploadList([]);
            setOssUploadList([]);
            setSourceLanguageVal('cn');
            fileListRef.current = [];
        } else {
            Toast.info(res?.msg || '查询失败');
            setLoadingBtn(false);
        }
    };
    const sourceLanguageOn = (e) => {
        setSourceLanguageVal(e.target.value);
        form.setFieldsValue({
            target_languages: 'no'
        });
    };
    const handleUpload = () => {
        form.validateFields()
            .then((res) => {
                let uploadListArr = [];
                if (uploadList && uploadList.length && res) {
                    const uploadingFiles = uploadList.filter((file) => file.status === 'active' && file.percent !== 100);

                    if (uploadingFiles.length > 0) {
                        Toast.info('有文件在上传中，请稍等提交');
                        return; // 如果有上传中的文件，终止后续操作
                    }
                    if (uploadList && uploadList.length === 0) {
                        return Toast.info('请选择上传的文件');
                    }
                    let filteredUploadList = uploadList.filter((file) => !(file.status === 'exception' && file.percent !== 100));
                    uploadListArr = filteredUploadList.map((file) => ({
                        document_dto: {...file},
                        ...res
                    }));
                    setLoadingBtn(true);
                    handleCreateFun(uploadListArr);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // 处理搜索
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
    };
    const handleSearchClick = () => {
        setCurrentPage(1);
        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: searchText,
            sort_by: sortValue,
            type: typeValue,
            source_language: languageValue,
            date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
            date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
        };
        setParams(params);
        handleGetTransInfoListFun(params);
    };
    // 处理排序
    const handleSort = (field) => {
        setSortValue(field);
        setCurrentPage(1);
        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: searchText,
            sort_by: field,
            type: typeValue,
            source_language: languageValue,
            date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
            date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
        };
        setParams(params);
        handleGetTransInfoListFun(params);
    };

    const handleSearchDelete = () => {
        setTypeValue('0');
        setLanguageValue('');
        setCurrentPage(1);
        setSearchText('');
        setSearchTextHig('');
        setSortValue('');
        setTypeValue('0');
        setTimeSetting([]);
        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: '',
            sort_by: '',
            type: '0',
            source_language: '',
            date_start: '',
            date_end: ''
        };
        handleGetTransInfoListFun(params, true);
    };

    // 处理分页变化
    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
        let params = {
            page_num: page,
            page_size: pageSize,
            key_words: searchText,
            sort_by: sortValue,
            type: typeValue,
            source_language: languageValue,
            date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
            date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
        };
        setParams(params);
        handleGetTransInfoListFun(params);
    };

    // 处理选择行
    const onSelectChange = (ele, e) => {
        setSelectedRowKeys((prevSelectedRowKeys) => {
            const newSelectedRowKeys = [...prevSelectedRowKeys]; // 创建之前选中状态的副本
            if (e.target.checked) {
                // 添加选中项
                newSelectedRowKeys.push(ele.document_id);
            } else {
                // 移除未选中项
                return newSelectedRowKeys.filter((v) => v !== ele.document_id);
            }
            return newSelectedRowKeys;
        });
    };

    const handleDeleteFun = async (ele, type) => {
        let res = await handleDelete({document_ids: ele});
        if (res && res.success) {
            Toast.info('删除成功');
            if (type === 1) {
                return handleGetTransListFun();
            }
            let params = {
                page_num: 1,
                page_size: pageSize,
                key_words: searchText,
                sort_by: sortValue,
                type: typeValue,
                source_language: languageValue,
                date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
                date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
            };
            handleGetTransInfoListFun(params);
        } else {
            Toast.info(res.msg || '操作失败');
        }
    };
    // 批量删除
    const handleBatchDelete = () => {
        if (selectedRowKeys.length === 0) {
            Toast.info('请选择一个音视频');
            return;
        }

        ConfirmTip({
            icon: null,
            title: '删除',
            content: (
                <div style={{
                    color: '#333333',
                    fontSize: '16px',
                    margin: '25px 0 40px',
                    lineHeight: '20px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <ExclamationCircleOutlined style={{color: '#FF8A39', fontSize: '20px', marginRight: '17px'}}/>
                    确定删除本记录吗?
                </div>
            ),
            okText: '删除',
            className: 'deleteBox',
            onOk: () => {
                handleDeleteFun(selectedRowKeys);
            }
        });
    };

    // 单个记录的删除
    const handleSingleDelete = (ele, type) => {
        if (type === 1) {
            return handleDeleteFun([ele.document_id], type);
        }
        ConfirmTip({
            icon: null,
            title: '删除',
            content: (
                <div style={{
                    color: '#333333',
                    fontSize: '16px',
                    margin: '25px 0 40px',
                    lineHeight: '20px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <ExclamationCircleOutlined style={{color: '#FF8A39', fontSize: '20px', marginRight: '17px'}}/>
                    确定删除本记录吗?
                </div>
            ),
            okText: '删除',
            className: 'deleteBox',
            onOk: () => {
                handleDeleteFun([ele.document_id]);
            }
        });
    };

    const handleIsFilterClick = () => {
        if (isFilterClick) {
            return setIsFilterClick(false);
        }
        return setIsFilterClick(true);
    };

    const handleIsBatchClick = () => {
        if (isBatchClick) {
            return setIsBatchClick(false);
        }
        return setIsBatchClick(true);
    };

    const handleTitleRenaming = (ele) => {
        setListTitle(ele.document_name);
        setListData(ele);
        setVisibleTitle(true);
    };
    const onCancel = () => {
        setListTitle('');
        setListData({});
        setVisibleTitle(false);
    };
    const handleOk = async () => {
        if (!listTitle || !listTitle.trim()) {
            return;
            // return Toast.info('请输入标题');
        }
        let parms = {
            document_name: listTitle
        };
        let res = await handleUpdateTitle(listData.document_id, parms);
        if (res && res.success) {
            setListTitle('');
            setListData({});
            setVisibleTitle(false);
            handleGetTransInfoListFun(params);
        } else {
            return Toast.info(res.msg || '操作失败');
        }
    };
    // 根据是否有选中项决定显示批量操作还是单个操作菜单
    const renderActions = (record) => {
        if (isBatchClick) {
            return (
                <Checkbox
                    onChange={(e) => {
                        e.stopPropagation();
                        onSelectChange(record, e);
                    }}
                    onClick={(e) => e.stopPropagation()}
                />
            );
        } else {
            const menu = [
                {
                    key: 'title',
                    label: (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                handleTitleRenaming(record);
                            }}
                        >
                            标题重命名
                        </div>
                    )
                },
                {
                    key: 'del',
                    label: (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSingleDelete(record);
                            }}
                        >
                            删除
                        </div>
                    )
                }
            ];
            return (
                <div className={s['top-dropdown']}>
                    <Dropdown
                        overlayClassName={s['operateBox']}
                        menu={{items: menu}}
                        trigger={['hover']}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                    >
                        <a
                            className={s['top-icon']}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                        >
                            <img src={addmoreIcon} alt={'addMoreIcon'}/>
                        </a>
                    </Dropdown>
                </div>
            );
        }
    };
    const handleType = (val) => {
        setTypeValue(val);
        setCurrentPage(1);
        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: searchText,
            sort_by: sortValue,
            type: val,
            source_language: languageValue,
            date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
            date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
        };
        setParams(params);
        handleGetTransInfoListFun(params);
    };
    const handleLanguageValue = (val) => {
        setLanguageValue(val);
        setCurrentPage(1);
        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: searchText,
            sort_by: sortValue,
            type: typeValue,
            source_language: val,
            date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
            date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
        };
        setParams(params);
        handleGetTransInfoListFun(params);
    };
    const onChange = (dates, dateStrings) => {
        const timestamps = dateStrings.map((dateString) => {
            // 创建一个 Date 对象
            const date = new Date(dateString);
            // 获取时间戳（毫秒数）
            return date.getTime();
        });
        setTimeSetting(timestamps);
        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: searchText,
            sort_by: sortValue,
            type: typeValue,
            source_language: languageValue,
            date_start: timestamps[0],
            date_end: timestamps[1]
        };
        if (dates === 'null' || dates === null) {
            setTimeSetting([]);
        }
        setParams(params);
        handleGetTransInfoListFun(params, currentPage);
    };

    const jumpInfo = (ele, e) => {
        if (ele.data_type === 'realtime' && ele.realtime_status === 1) return;
        e.stopPropagation(); // 阻止事件冒泡
        props.navigate(`/web/o/${agentId}/tools/${toolId}/${ele.document_id}`);
    };
    const highlightMatches = (text) => {
        if (text) {
            const regex = new RegExp(`(${searchTextHig})`, 'gi'); // 正则表达式
            return text
                .split(regex)
                .map((part, index) => (part.toLowerCase() === searchTextHig.toLowerCase() ?
                    <span key={index}>{part}</span> : part));
        } else {
            return text;
        }
    };
    const validFileList = () => {
            if (!uploadList?.length) {
                return Promise.reject('请选择上传的文件');
            }
            return Promise.resolve();
        },
        getFileExtAndName = (fileName) => {
            const index = fileName.lastIndexOf('.'),
                ext = fileName.substring(index + 1),
                name = fileName.substring(0, index);
            return {fileExt: ext, fileName: name};
        },
        ossUploadCompleteFunc = (result) => {
            for (let i = 0, len = ossUploadList.length; i < len; i++) {
                const ossItem = ossUploadList[i];
                if (ossItem['fileName'] === result.objectKey) {
                    ossItem.status = 'success';
                    ossItem.percent = 100;
                    ossItem.uploadSize = ossItem.totalSize;
                    ossItem.totalSize = ossItem.size;
                    ossItem.fileUrl = result.fileUrl;
                }
            }
            setOssUploadList(ossUploadList);
        },
        fileChange = (file) => {
            setLoading(true);
            let flag = true;
            if (file.size > 6 * 1024 * 1024 * 1024) flag = false;
            if (!flag) {
                Toast.info('文件大小超出限制');
                setLoading(false);
                return false;
            }
            return true;
        },
        ossProcessFunc = (process, file, xhr, obsResult) => {
            for (let i = 0, len = ossUploadList.length; i < len; i++) {
                const ossItem = ossUploadList[i];
                if (ossItem['fileName'] === obsResult.objectKey) {
                    ossItem.status = 'active';
                    ossItem.percent = Math.floor(process * 100);
                    ossItem.uploadSize = process * file.size;
                    ossItem.totalSize = ossItem.size;
                    ossItem.md5 = obsResult.md5;
                    ossItem.fingerprint = obsResult.md5;
                    ossItem.xhr = xhr;
                }
            }
            setOssUploadList(ossUploadList);
        },
        uploadFileErrorHandle = (error, file, obsResult) => {
            if (error.message) {
                if (error.message === '文件格式不支持') {
                    Toast.info('文件非可处理文件，建议上传支持的音视频文件');
                    setLoading(false);
                    return;
                }
                Toast.info('文件已存在、类型不支持或大小超限');
                setLoading(false);
            } else {
                const list = cloneDeep(uploadList);
                for (let i = 0, len = list.length; i < len; i++) {
                    const uploadItem = list[i];
                    if (uploadItem['fileName'] === obsResult.objectKey) {
                        uploadItem.status = 'exception';
                        uploadItem.totalSize = uploadItem.size;
                    }
                }
                setUploadList(list);
                setLoading(false);
            }
        },
        completeItemUpload = async (result) => {
            const list = uploadList;
            for (let i = 0, len = list.length; i < len; i++) {
                const uploadItem = list[i];
                if (uploadItem['fileName'] === result.objectKey) {
                    const {fileExt, fileName} = getFileExtAndName(uploadItem.name);
                    uploadItem.type = getCourseEditingUploadType(uploadItem['type']);
                    uploadItem.open = getPrivateOrPublic(uploadItem['type']);
                    uploadItem.bucket = result.bucketName;
                    uploadItem.name = fileName.substring(0, 50);
                    uploadItem.ext_type = fileExt;
                    uploadItem.size = uploadItem.totalSize;
                    uploadItem.obs_id = uploadItem.fileName;
                    uploadItem.default_url = result.fileUrl;
                    uploadItem.fingerprint = uploadItem.md5;
                    uploadItem.percent = 100;
                    uploadItem.status = 'success';
                }
            }
            setUploadList(cloneDeep(list));
            fileListRef.current = cloneDeep(list);
        },
        updateProcess = (process, file, xhr, obsResult) => {
            const list = cloneDeep(uploadList);
            for (let i = 0, len = list.length; i < len; i++) {
                const uploadItem = list[i];
                if (uploadItem['fileName'] === obsResult.objectKey) {
                    uploadItem.status = 'active';
                    uploadItem.percent = Math.floor(process * 100);
                    uploadItem.uploadSize = process * file.size;
                    uploadItem.totalSize = uploadItem.size;
                    uploadItem.md5 = obsResult.md5;
                    uploadItem.xhr = xhr;
                }
            }
            setUploadList(list);
        },
        beforeUploadHandle = async (file, name, md5, fileType) => {
            if (fileType === UploadType.UNSET) {
                Toast.error('文件非可处理文件，建议上传支持的音视频文件');
                setLoading(false);
                return false;
            }
            for (let i = 0, len = uploadList.length; i < len; i++) {
                const item = uploadList[i];
                if (item['fileName'] === name && item.status !== 'exception') {
                    Toast.error('文件已存在、类型不支持或大小超限');
                    setLoading(false);
                    return false;
                }
            }
            if (fileListRef.current.length >= 10) {
                Toast.error('单次最多可上传处理10个文件');
                setLoading(false);
                return false;
            }
            const tmp = {
                key: name,
                name: file.name,
                fileName: name,
                status: 'normal',
                md5,
                uploadSize: 0,
                totalSize: file.size,
                size: file.size,
                type: fileType,
                fingerprint: md5,
                percent: 0
            };
            uploadList.push(tmp);
            setUploadList(cloneDeep(uploadList));
            setLoading(false);
            fileListRef.current = cloneDeep(uploadList);
            setOssUploadList(cloneDeep(uploadList));
        },
        confirmDelete = (data) => {
            const uploadLists = uploadList;
            uploadLists.forEach((item, index) => {
                if (item.name === data.name) {
                    uploadLists.splice(index, 1);
                }
            });
            setUploadList(cloneDeep(uploadLists));
            fileListRef.current = cloneDeep(uploadLists);
            // if (data.obs_id) {
            //     ConfirmTip({
            //         title: '确认删除该文件？',
            //         content: '',
            //         onOk: () => {
            //             uploadLists.forEach((item, index) => {
            //                 if (item.name === data.name) {
            //                     uploadLists.splice(index, 1);
            //                 }
            //             });
            //             setUploadList(cloneDeep(uploadLists));
            //         }
            //     });
            // } else {
            //     if (data.percent !== 100 && data.status !== 'exception') {
            //         ConfirmTip({
            //             title: '文件正在上传，确认删除该文件？',
            //             content: '',
            //             onOk: () => {
            //                 uploadLists.forEach((item, index) => {
            //                     if (item.name === data.name) {
            //                         uploadLists.splice(index, 1);
            //                     }
            //                 });
            //                 setUploadList(uploadLists);

            //             }
            //         });
            //     } else {
            //         uploadLists.forEach((item, index) => {
            //             if (item.name === data.name) {
            //                 uploadLists.splice(index, 1);
            //             }
            //         });
            //         setUploadList(uploadLists);
            //     }
            // }
        };
    useEffect(() => {
        const toolData = grtAi?.state?.currentAgent?.scene_tool;
        if (toolData && toolData.length > 0) {
            const exists = toolData.some((tool) => tool.tool_id === 1 || tool.tool_id === '1');

            if (!exists) {
                Toast.info('该智能体未对外开放使用，请联系管理员');
                return setIsToolTw(true);
            }
            setIsToolTw(false);
        } else {
            setIsToolTw(true);
            Toast.info('该智能体未对外开放使用，请联系管理员');
        }

        let params = {
            page_num: 1,
            page_size: pageSize,
            key_words: searchText,
            sort_by: sortValue,
            type: typeValue,
            source_language: languageValue,
            date_start: timeSetting && timeSetting.length ? timeSetting[0] : '',
            date_end: timeSetting && timeSetting.length ? timeSetting[1] : ''
        };
        setParams(params);
        handleGetTransInfoListFun(params);
        handleGetTransListFun();
        checkIsLogin();
        checkCanUseFun();
    }, []);
    useEffect(() => {
        if (form && visibleAdd) {
            form.setFieldsValue({
                speaker_count: 1,
                source_language: 'cn',
                target_languages: 'no'
            });
        }
    }, [form, visibleAdd]);
    return (
        <div className={s['wrapper']}>
            <Display show={isCheckCanUse || isToolTw}>
                <div className={s['isCheckCanUse']}></div>
            </Display>
            <div>
                <h3 className={s['wrapper-title']}>音视频转录</h3>
                <div className={s['wrapper-search']}>
                    <div className={s['top-search']}>
                        <div className={s['top-addBtn']}>
                            <Dropdown
                                overlayClassName={s['addItem']}
                                menu={{
                                    items: [
                                        {
                                            key: 'uplod',
                                            label: (
                                                <span onClick={handleAdd}>
                                                    <img
                                                        src={addIcon}
                                                        width={16}
                                                        height={16}
                                                        style={{marginRight: '10px', verticalAlign: '-2px'}}
                                                        alt={'addIcon'}
                                                    />
                                                    上传本地音视频文件
                                                </span>
                                            )
                                        },
                                        {
                                            key: 'realTime',
                                            label: (
                                                <span onClick={handleAddRecord}>
                                                    <img src={addIcon1} width={16} height={16}
                                                         style={{marginRight: '10px', verticalAlign: '-2px'}}
                                                         alt={'addIcon1'}/>开启实时记录
                                                </span>
                                            )
                                        }
                                    ]
                                }}
                                trigger={['click']}
                            >
                                <div className={s['addbtn']}>
                                    <Button type="primary">新建</Button>
                                </div>
                            </Dropdown>
                        </div>
                        <div className={s['top-search']}>
                            <Input
                                className={s['searchInput']}
                                addonBefore={<SearchOutlined style={{cursor: 'pointer'}} onClick={handleSearchClick}/>}
                                onPressEnter={handleSearchClick}
                                maxLength={50}
                                onChange={handleSearch}
                                value={searchText}
                                placeholder="搜索标题/标签"
                            />
                            <Dropdown
                                overlayClassName={s['transListData']}
                                menu={{
                                    items:
                                        transList && transList.length
                                            ? transList.map((record) => ({
                                                key: record.document_id,
                                                label: (
                                                    <div className={s['transItem']}>
                                                        <div className={s['transItem-title']}>
                                                            <p>
                                                                <img src={record.type === 2 ? videoImg : autioImg}
                                                                     alt={''}/>
                                                                <span>{record.document_name}</span>
                                                            </p>
                                                            <Button className={s['transItem-del']}
                                                                    onClick={() => handleSingleDelete(record, 1)}>
                                                                X
                                                            </Button>
                                                        </div>
                                                        {/* 1  进行中，3 失败 */}
                                                        {record.ai_txt_status === 1 ? (
                                                            <p className={s['transItem-ing']}>转写中...</p>
                                                        ) : (
                                                            <p className={s['transItem-fail']}>
                                                                <span>转写失败</span>
                                                                {record?.close_retry_tag === 1 ? null : (
                                                                    <Button
                                                                        className={s['transItem-retry']}
                                                                        loading={retryLoading}
                                                                        onClick={() => handleRetryTransFun(record)}
                                                                    >
                                                                        重新转写
                                                                    </Button>
                                                                )}
                                                            </p>
                                                        )}
                                                    </div>
                                                )
                                            }))
                                            : [
                                                {
                                                    key: 'no-records',
                                                    label: (
                                                        <div className={s['transItemNo']} style={{textAlign: 'center'}}>
                                                            暂无数据
                                                        </div>
                                                    )
                                                }
                                            ]
                                }}
                                trigger={['click']}
                            >
                                <div className={s['transList']} onClick={handleGetTransListFun}>
                                    <Display show={transList?.length > 0}>
                                        <SyncOutlined spin style={{color: '#3b70ff', fontSize: '14px'}}/>
                                        <p style={{color: '#3b70ff'}}>处理进度</p>
                                    </Display>
                                    <Display show={transList?.length === 0}>
                                        <p>处理进度</p>
                                    </Display>
                                </div>
                            </Dropdown>
                            <div className={s['line']} style={{margin: '0px'}}></div>
                            <Select onChange={(value) => handleSort(value)} placeholder="排序"
                                    className={s['searchSelectCt']}>
                                <Select.Option value="ctDesc">创建时间降序</Select.Option>
                                <Select.Option value="ctAsc">创建时间升序</Select.Option>
                            </Select>
                            <div className={s['line']} style={{marginLeft: '0px'}}></div>
                            <Button className={s['btn']} onClick={handleIsFilterClick}>
                                高级筛选
                            </Button>
                            <div className={s['line']}></div>
                            <Button className={s['btn']} onClick={handleIsBatchClick}>
                                批量
                            </Button>
                        </div>
                    </div>

                    <Display show={isFilterClick}>
                        <div className={s['filterBox']}>
                            <Select style={{width: 120, marginRight: 8}}
                                    onChange={(value) => handleLanguageValue(value)} value={languageValue}>
                                {languageOptionsSearch.map((option) => (
                                    <Select.Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Select.Option>
                                ))}
                            </Select>
                            <Select style={{width: 120, marginRight: 8}} onChange={(value) => handleType(value)}
                                    value={typeValue}>
                                <Select.Option value="0">全部类型</Select.Option>
                                <Select.Option value="2">视频</Select.Option>
                                <Select.Option value="3">音频</Select.Option>
                            </Select>
                            <RangePicker
                                onChange={onChange}
                                value={timeSetting.length > 0 ? [dayjs(timeSetting[0]), dayjs(timeSetting[1])] : null}
                                placeholder={['开始时间', '结束时间']}
                            />
                            <Button onClick={handleSearchDelete} style={{marginLeft: 8}}>
                                清空筛选
                            </Button>
                        </div>
                    </Display>
                    <Display show={isBatchClick}>
                        <div style={{marginTop: 16}}>
                            <Button onClick={handleBatchDelete} danger>
                                批量删除
                            </Button>
                        </div>
                    </Display>
                </div>
                <div className={s['wrapper-item']}>
                    <Display show={loadingList}>
                        <div style={{width: '100%', textAlign: 'center'}}>
                            <Spin spinning={loadingList}/>
                        </div>
                    </Display>
                    <Display show={!loadingList}>
                        <div className={s['item-list']}>
                            {!loadingList && records && records.length > 0 ? (
                                records.map((record, index) => (
                                    <div className={s['list-box']} key={record.document_id}
                                         onClick={(e) => jumpInfo(record, e)}>
                                        <div className={s['list-top']}>
                                            <h3 className={s['list-title']}>{highlightMatches(record.document_name)}</h3>
                                            {
                                                record.data_type === 'realtime' && record.realtime_status === 1 ? null :
                                                    <div className={s['list-btn']}>{renderActions(record)}</div>
                                            }
                                        </div>
                                        {
                                            record.data_type === 'realtime' && record.realtime_status === 1 ?
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                    padding: '22px 0px 33px',
                                                    gap: '10px',
                                                    height: '92px',
                                                    justifyContent: 'space-between',
                                                }}>
                                                    <img src={Record} width={68} alt={'录音'}/>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: 'column',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span style={{
                                                            fontWeight: 400,
                                                            fontSize: 12,
                                                            color: 'rgba(72,97,149,0.7)'
                                                        }}>正在录音中</span>
                                                        <span style={{
                                                            fontWeight: 400,
                                                            fontSize: 12,
                                                            color: 'rgba(72,97,149,0.7)'
                                                        }}>停止录音后才能继续查看</span>
                                                    </div>
                                                </div>
                                                : <>
                                                    <div className={s['list-keyWords']}>
                                                        {record.key_words &&
                                                            record.key_words.length ?
                                                            record.key_words.map((keyWords, index) => <span
                                                                key={index}>{keyWords}</span>):null}
                                                    </div>
                                                    <div className={s['list-type']}>
                                                        {record.type === 2 || record.type === '2' ? (
                                                            <div
                                                                className={s['listImg']}
                                                                style={{
                                                                    background: `url(${record.thumbnail_url}) no-repeat center`,
                                                                    backgroundSize: 'cover'
                                                                }}
                                                            ></div>
                                                        ) : (
                                                            <p>{record.summarization}</p>
                                                        )}
                                                    </div>
                                                </>
                                        }
                                        <div className={s['list-footer']}>
                                            <div className={s['footer-lf']}>{ record.data_type === 'realtime' && record.realtime_status === 1 ? null : Utils.formatTime(record.duration)}</div>
                                            <div className={s['footer-rg']}>{formatDate(record.complete_time)}</div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className={s['error-box']}>
                                    <img className={s['error-img']} src={emtyImg} alt=""/>
                                    <div className={s['error-text']}>暂无数据哦~</div>
                                </div>
                            )}
                        </div>
                    </Display>
                </div>
                <div className={s['item-pag']}>
                    <Pagination
                        showSizeChanger
                        hideOnSinglePage={list?.total <= 8}
                        pageSizeOptions={[8, 16, 40, 80]}
                        align={'center'}
                        current={currentPage}
                        pageSize={pageSize}
                        total={list?.total}
                        onChange={handlePageChange}
                        showLessItems={true}
                    />
                </div>
                <Modal
                    title="标题重命名"
                    open={visibleTitle}
                    onCancel={onCancel}
                    width={500}
                    style={{top: '25%'}}
                    destroyOnHidden
                    footer={[
                        <Button key="submit" type="primary" onClick={handleOk}>
                            确定
                        </Button>,
                        <Button key="cancel" onClick={onCancel}>
                            取消
                        </Button>
                    ]}
                    wrapClassName={s['titleModal']}
                >
                    <div style={{margin: ' 30px 0 40px'}}>
                        <div className={s['rename']}>
                            <div className={s['renameLable']}>请输入标题</div>
                            <Input onChange={(e) => setListTitle(e.target.value)} maxLength={50} showCount
                                   placeholder="请输入" value={listTitle}/>
                        </div>
                        <Display show={!listTitle || !listTitle.trim()}>
                            <div style={{color: 'red', marginLeft: '80px'}}>请输入标题</div>
                        </Display>
                    </div>
                </Modal>
                <Modal
                    title="上传本地音视频文件"
                    open={visibleAdd}
                    onCancel={onCancelAdd}
                    footer={null}
                    destroyOnHidden
                    width={800}
                    className={s['addForm']}
                    style={{top: '25%'}}
                >
                    <Form layout="vertical" form={form}>
                        <div className={s['addForm-wrapper']}>
                            <div className={s['addForm-lf']}>
                                <Form.Item
                                    label={null}
                                    name="document"
                                    rules={[
                                        {
                                            required: true,
                                            validator: validFileList
                                        }
                                    ]}
                                >
                                    <ServiceUpload
                                        uploadOss={true}
                                        ossUploadCompleteFunc={ossUploadCompleteFunc}
                                        multiple={true}
                                        dirname={tenant_id}
                                        onChange={fileChange}
                                        errorFunc={uploadFileErrorHandle}
                                        completeFunc={completeItemUpload}
                                        processFunc={updateProcess}
                                        ossProcessFunc={ossProcessFunc}
                                        beforeUpload={beforeUploadHandle}
                                        maxSize={1024 * 1024 * 1024 * 6}
                                        maxSizeAudio={500 * 1024 * 1024}
                                        uploadItem={
                                            <div className={s['uploadItem']}>
                                                <Spin spinning={loading}>
                                                    {uploadList && uploadList?.length > 0 ? (
                                                        <div className={s['continueAdding']}>
                                                            <PlusCircleOutlined style={{
                                                                color: '#3B70FF',
                                                                fontSize: '14px',
                                                                marginRight: '4px'
                                                            }}/>
                                                            继续添加
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className={s['uploadItem-box']}>
                                                                <img src={uploadImg} width={80} height={80}
                                                                     alt={'uploadImg'}/>
                                                                <p>
                                                                    <span>点击／拖拽</span>本地音视频文件到这里
                                                                </p>
                                                            </div>
                                                            <div className={s['uploadItemTip']}>
                                                                <div>单个文件最长6小时,单次最多可上传10个。</div>
                                                                <div>
                                                                    视频支持:mp4/wmv/m4v/flv/rmvb/dat/mov/mkv/
                                                                    <br/>
                                                                    webm/avi/mpeg/3gp/ogg，单个最大6G;
                                                                </div>
                                                                <div>
                                                                    音频支持:mp3/wav/m4a/wma/aac/ogg/amr/
                                                                    <br/>
                                                                    flac/aiff，单个最大500M。
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Spin>
                                            </div>
                                        }
                                    />

                                    <div className={s['uploadList-item']}>
                                        {uploadList &&
                                            uploadList?.length > 0 &&
                                            uploadList.map((file, index) => (
                                                <div className={s['uploadList-list']} key={index}>
                                                    <div className={s['list-title']}>
                                                        <div className={s['title']}>
                                                            <img src={file.type === 2 ? videoImg : autioImg} alt={''}/>
                                                            <span>{file.name}</span>
                                                        </div>
                                                        <div className={s['list-con']}>
                                                            <Button type={'link'} onClick={() => confirmDelete(file)}>
                                                                <CloseOutlined
                                                                    style={{color: '#486195', fontSize: '14px'}}/>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    <div className={s['list-status']}>
                                                        {file.status === 'active' || file.status === 'normal' ? (
                                                            <span style={{color: '#666'}}>上传中...</span>
                                                        ) : (file.status === 'success' && file.percent === 100) || !file.status ? (
                                                            <span
                                                                style={{color: '#07C160'}}>{Utils.formatSize(file.totalSize)}</span>
                                                        ) : file.status === 'exception' ? (
                                                            <span style={{color: '#FF4D4F'}}>上传失败</span>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </Form.Item>
                            </div>

                            <div className={s['addForm-rg']}>
                                <Form.Item name="source_language" label="音视频语言">
                                    <Radio.Group block optionType="button" buttonStyle="solid"
                                                 onChange={sourceLanguageOn}>
                                        {sourceLanguageOptions.map((option) => (
                                            <Radio key={option.value} value={option.value}>
                                                {option.label}
                                            </Radio>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>

                                <Form.Item name="target_languages" label="翻译">
                                    <Select style={{width: '100%'}}
                                            disabled={sourceLanguageVal === 'yue' || sourceLanguageVal === 'fspk'}>
                                        <Select.Option key={'no'} value={'no'}>
                                            不翻译
                                        </Select.Option>
                                        {(() => {
                                            switch (sourceLanguageVal) {
                                                case 'en':
                                                    return (
                                                        <>
                                                            <Select.Option key={'cn'} value={'cn'}>
                                                                中文
                                                            </Select.Option>
                                                            <Select.Option key={'ja'} value={'ja'}>
                                                                日语
                                                            </Select.Option>
                                                            break;
                                                        </>
                                                    );
                                                case 'cn':
                                                    return (
                                                        <>
                                                            <Select.Option key={'en'} value={'en'}>
                                                                英语
                                                            </Select.Option>
                                                            <Select.Option key={'ja'} value={'ja'}>
                                                                日语
                                                            </Select.Option>
                                                            break;
                                                        </>
                                                    );
                                                case 'ja':
                                                    return (
                                                        <>
                                                            <Select.Option key={'cn'} value={'cn'}>
                                                                中文
                                                            </Select.Option>
                                                            <Select.Option key={'en'} value={'en'}>
                                                                英语
                                                            </Select.Option>
                                                            break;
                                                        </>
                                                    );
                                                default:
                                                    return null;
                                            }
                                        })()}
                                    </Select>
                                </Form.Item>

                                <Form.Item name="speaker_count" label="区分发言人" className={s['speakerList']}>
                                    <Radio.Group block optionType="button" buttonStyle="solid">
                                        {speakerOptions.map((option) => (
                                            <Radio key={option.value} value={option.value}>
                                                {option.label}
                                            </Radio>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                                <div>
                                    <Button
                                        key="submit"
                                        type="primary"
                                        onClick={handleUpload}
                                        disabled={uploadList.length === 0}
                                        style={{marginRight: '16px'}}
                                        loading={loadingBtn}
                                    >
                                        开始转写
                                    </Button>
                                    <Button key="cancel" onClick={onCancelAdd}>
                                        取消
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Modal>
            </div>
        </div>
    );
};
export default withRouter(inject('store')(observer(MeetingPlatform)));
